import { GroupsSearchBarStyles } from "./GroupsBlock.styles";
import ServerSideSearchBar from "../../../components/common/table/ServerSideSearchBar";
import SearchBarButtonContainer from "../../../components/common/table/SearchBarButtonContainer";
import { usePermissionChecker } from "../../../hooks/usePermissionChecker";
import { PermissionEntityType } from "../../../types/permissionType";
import { Stack } from "@mui/material";
import { t } from "i18next";
import { FilterButtonDropDown } from "../../../common/ui/FilterButtonDropdown";
import { GroupFilterParameters, GroupsPageFiltersResponse, LookupResponse } from "../../../types/groupPageFilters";

interface GroupsSearchBarProps {
  handleOnSearch: (searchQuery: string) => void;
  handleOnCreateGroup: () => void;
  filterOptions: GroupsPageFiltersResponse;
  selectedFilters: GroupFilterParameters;
  onFilterChange: (filter: Partial<GroupFilterParameters>) => void;
}

export default function GroupsSearchBar(props: GroupsSearchBarProps) {
  const { userHasPermission } = usePermissionChecker();
  const canCreateGroup = userHasPermission(PermissionEntityType.Groups, "Create");

  const listFilters: { key: keyof GroupFilterParameters; label: string; options: LookupResponse[] }[] = [
    { key: "actionModuleIds", label: t("groupsPage.filters.actionModules"), options: props.filterOptions.actionModules },
    { key: "serviceModuleIds", label: t("groupsPage.filters.serviceModules"), options: props.filterOptions.serviceModules },
    { key: "shopModuleIds", label: t("groupsPage.filters.shopModules"), options: props.filterOptions.shopModules },
  ];

  return (
    <GroupsSearchBarStyles>
      <Stack direction="row" spacing={1} sx={{ flexWrap: "wrap", rowGap: 1, alignItems: "center" }}>
        <ServerSideSearchBar onSearchHandler={props.handleOnSearch} />
        {listFilters.map(({ key, label, options }) => (
          <FilterButtonDropDown
            key={key}
            label={label}
            options={options}
            selectedIds={props.selectedFilters[key]}
            onToggle={(id) => props.onFilterChange({
              [key]:
                props.selectedFilters[key].includes(id)
                  ? props.selectedFilters[key].filter((x) => x !== id)
                  : [...props.selectedFilters[key], id]
            })}
            onReset={() => props.onFilterChange({ [key]: [] })}
          />
        ))}
      </Stack>
      <SearchBarButtonContainer onCreateClick={canCreateGroup ? props.handleOnCreateGroup : undefined} />
    </GroupsSearchBarStyles>
  );
};
